import './lib/uuid';
import { Factory } from 'rosie';

Factory.define('SnippetSearchResult')
  .extend('Uuid')
  .attr('query', ['query'], query => {
    return Factory.attributes('SearchQuery', query);
  })
  .attr('requestedAt');
